"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vatRatesQuerySchema = void 0;
const zod_1 = require("zod");
exports.vatRatesQuerySchema = zod_1.z.object({
    date: zod_1.z
        .string()
        .trim()
        .regex(/^\d{4}-\d{2}-\d{2}$/, 'Data trebuie să fie în formatul YYYY-MM-DD.')
        .optional(),
});
